export default "__VITE_ASSET__CzF6feLy__"